import React from 'react';
import PropTypes from 'prop-types';

import { calculateProfitAfterTax, calculateProfitBeforeTax } from '../../helpers/calculations';
import formatPrice from '../../helpers/formatPrice';

import styles from './styles.module.scss';

export default function Scenarios({ data, diffInYears }) {
  const { q, ec, section102, tax } = data;

  const calcProfitAfterTax = (multiplier) => {
    const p = parseFloat(ec) * multiplier;
    const profitBeforeTax = calculateProfitBeforeTax(ec, p, q);

    return calculateProfitAfterTax(profitBeforeTax, section102, diffInYears, tax);
  };

  const multipliers = [1.5, 3, 5];
  const classNames = ['mb-2 mb-md-0 col-12 col-sm-8 col-md-4', 'mb-2 mb-md-0 col-12 col-sm-8 col-md-4', 'col-12 col-sm-8 col-md-4'];

  return (
    <div className='row justify-content-center'>
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div className={classNames[index]} key={index}>
            <div className={styles.scenario}>
              <div>
                אקזיט לפי מחיר מניה <span className='color-green'>{formatPrice(ec * multipliers[index])}</span>
              </div>
              <div>
                (מכפיל רווח <strong>{multipliers[index]}x</strong>)
              </div>
              <div>
                רווח: <span className='color-green'>{formatPrice(q * (multipliers[index] - 1) * ec)}</span>
              </div>
              <div>
                רווח אחרי מס: <span className='color-green'>{formatPrice(calcProfitAfterTax(multipliers[index]))}</span>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

Scenarios.propTypes = {
  data: PropTypes.object,
  diffInYears: PropTypes.number
};
